<header class="header-container w-full flex items-center justify-between relative">
  <div class="flex items-center">
    <div
      class="flex justify-between w-[238px] items-center px-3 header-logo-container"
      [class.logo-container-reduced]="sidenavCollapsed$ | async"
    >
      <div class="header-logo">
        <a routerLink="/"><img class="max-h-full" src="/assets/rk-logo.png" /></a>
      </div>
      @if ((isCreationProcess$ | async) === false) {
        <div class="cursor-pointer" (click)="toggleSidenav()">
          @if (sidenavCollapsed$ | async) {
            <img src="/assets/menu-uncollapsed.svg" />
          } @else {
            <img src="/assets/menu-collapse.svg" />
          }
        </div>
      }
    </div>

    @if ((isCreationProcess$ | async) === false && (apps$ | async)?.length > 1) {
      <div class="dropdown">
        <rk-list></rk-list>
      </div>
    }
  </div>
  @if (currentAppIsNotOwnedByUser$ | async) {
    <rk-admin-warning></rk-admin-warning>
  }
  @if (userName$ | async) {
    <div class="flex items-center">
      @if (isLocal) {
        <rk-language-switcher class="mr-2"></rk-language-switcher>
      }
      <div class="flex items-center gap-2 mr-4">
        <a [href]="'header.help-link' | translate" target="_blank">
          <fa-icon
            [icon]="'question'"
            class="help-icon flex justify-center items-center"
          ></fa-icon>
        </a>
        <div>
          <fa-icon
            [icon]="'bell'"
            class="changelog-icon flex justify-center items-center"
          >
          </fa-icon>
          <div class="headway-widget"></div>
        </div>
      </div>
      <rk-user-menu></rk-user-menu>
    </div>
  }
</header>
